// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"CheckoutFormGroupHeader_Wrapper__JJ56p","TitleText":"CheckoutFormGroupHeader_TitleText__1Xq47"};